/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import axios from "axios";
import cookie from "react-cookies";
import { ToastContainer, toast } from "react-toastify";
import DatePicker from "react-datepicker";
import { UNIFIED_BASE_URL } from "../webbase";
import { CSVLink } from "react-csv";

const DailySummary = () => {
  const [walletBalance] = useState(cookie.load("walletBalance"));
  const [token] = useState(cookie.load("token"));
  const [vouchers, setVouchers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const getYesterday = () => {
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    return yesterday;
  };

  const [startDate, setStartDate] = useState(getYesterday());
  const [endDate, setEndDate] = useState(getYesterday());

  const [getDealer, setGetDealer] = useState([]);
  const [getMerchant, setGetMerchant] = useState([]);
  const [dealer, setDealer] = useState("");
  const [merchant, setMerchant] = useState("");

  function makeShortDate(date) {
    const yy = date.getFullYear();
    const mm = date.getMonth() + 1;
    const dd = date.getDate();
    return `${yy}-${mm < 10 ? "0" : ""}${mm}-${dd < 10 ? "0" : ""}${dd}`;
  }

  const getDailyTransactions = async () => {
    const datee = makeShortDate(startDate);
    const yesterday = makeShortDate(endDate);
    const api = "/dealer/daily-summarry-dealer";
    const queryParams = new URLSearchParams();
    if (datee) queryParams.append("startDate", datee);
    if (yesterday) queryParams.append("endDate", yesterday);
    if (dealer && merchant) queryParams.append("merchantId", merchant);
    if (dealer) queryParams.append("dealerId", dealer);

    try {
      const res = await axios.get(
        `${UNIFIED_BASE_URL}${api}?${queryParams.toString()}`,
        { headers: { authorization: token } }
      );

      if (res.data.status !== "4000") {
        setVouchers(res.data.data);
        setCurrentPage(1); // Reset to first page when new data is loaded
      }
    } catch (err) {
      toast.error("Error fetching transactions");
      console.error(err);
    }
  };

  useEffect(() => {
    getDailyTransactions();
  }, [startDate, endDate, dealer, merchant]);

  useEffect(() => {
    const fetchDealerData = async () => {
      try {
        const res = await axios.get(`${UNIFIED_BASE_URL}/manage/get-dealer`, {
          headers: { authorization: token },
        });

        if (res.data.status !== "4000") {
          setGetDealer(res.data.data);
        }
      } catch (err) {
        toast.error("Error fetching dealers");
        console.error(err);
      }
    };

    fetchDealerData();
  }, [token]);

  useEffect(() => {
    const fetchMerchantData = async () => {
      try {
        const res = await axios.get(
          `${UNIFIED_BASE_URL}/onboarding/stp-users?dealerId=${dealer}`,
          { headers: { authorization: token } }
        );

        if (res.data.status !== "4000") {
          setGetMerchant(res.data.data.merchants);
        }
      } catch (err) {
        toast.error("Error fetching merchants");
        console.error(err);
      }
    };

    if (dealer) {
      fetchMerchantData();
    }
  }, [token, dealer]);

  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "NGN",
  });

  // Pagination settings
  const pageSize = 15; // Changed from 50 to 15 items per page
  const totalPages = Math.ceil(vouchers.length / pageSize);
  
  // Calculate the current page's data slice
  const transactionsToDisplay = vouchers.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  // Handle page change
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <main className="page-content">
      <ToastContainer position="top-center" autoClose={3000} />

      <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb mb-0 p-0">
            <li className="breadcrumb-item">
              <a href="#"><i className="bx bx-home-alt"></i></a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Daily Summary
            </li>
          </ol>
        </nav>
      </div>

      <div className="card">
        <div className="card-body">
          <form>
            <div className="row g-3 align-items-end">
              {/* Date Pickers */}
              <div className="col-12 col-md-2">
                <div className="form-group">
                  <label>Start Date:</label>
                  <DatePicker
                    className="form-control"
                    selected={startDate}
                    onChange={setStartDate}
                    maxDate={new Date()}
                  />
                </div>
              </div>
              <div className="col-12 col-md-2">
                <div className="form-group">
                  <label>End Date:</label>
                  <DatePicker
                    className="form-control"
                    selected={endDate}
                    onChange={setEndDate}
                    maxDate={new Date()}
                  />
                </div>
              </div>

              {/* Dealer Select */}
              <div className="col-12 col-md-3">
                <div className="form-group">
                  <label>Select Dealer</label>
                  <select
                    className="form-control"
                    value={dealer}
                    onChange={(e) => {
                      setDealer(e.target.value);
                      setMerchant("");
                    }}
                  >
                    <option value="">Select Dealer</option>
                    {getDealer.map((e) => (
                      <option key={e.id} value={e.dealerId}>
                        {e.businessName}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {/* Merchant Select */}
              {dealer && (
                <div className="col-12 col-md-3">
                  <div className="form-group">
                    <label>Select Merchant</label>
                    <select
                      className="form-control"
                      value={merchant}
                      onChange={(e) => setMerchant(e.target.value)}
                    >
                      <option value="">Select Merchant</option>
                      {getMerchant.map((e) => (
                        <option key={e.id} value={e.merchantId}>
                          {e.businessEmail}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              )}

              {/* CSV Export Button */}
              <div className="col-12 col-md-2 ms-auto">
                <CSVLink
                  data={vouchers}
                  filename={"Dailysummary.csv"}
                  target="_blank"
                  className="w-100"
                >
                  <button
                    className="btn btn-primary w-100 d-flex align-items-center justify-content-center"
                    type="button"
                  >
                    <i className="bi bi-cloud-arrow-down-fill me-2"></i>
                    Export CSV
                  </button>
                </CSVLink>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <div className="table-responsive">
            <table className="table align-middle mb-0">
              <thead className="table-light">
                <tr>
                  <th>Face value</th>
                  <th>Discounted Amount</th>
                  <th>Amount Debited</th>
                  <th>Network</th>
                  <th>Account id</th>
                  <th>Dealer ID</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {transactionsToDisplay.length !== 0 ? (
                  transactionsToDisplay.map((e, index) => (
                    <tr key={index}>
                      <td>{formatter.format(e?.faceValue)}</td>
                      <td>{formatter.format(e?.discountedAmount)}</td>
                      <td>{formatter.format(e?.amountDebited)}</td>
                      <td>{e?.network}</td>
                      <td>{e?.accountid}</td>
                      <td>{e?.dealerId}</td>
                      <td>
                        {e.transDate
                          ? new Date(e.transDate).toLocaleString()
                          : "N/A"}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7">No Record.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          
          {/* Pagination Controls */}
          {vouchers.length > 0 && (
            <nav className="float-end mt-3">
              <ul className="pagination">
                {/* Previous Button */}
                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                  <a 
                    className="page-link" 
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      if (currentPage > 1) handlePageChange(currentPage - 1);
                    }}
                  >
                    Previous
                  </a>
                </li>
                
                {/* Page Numbers */}
                {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
                  <li 
                    key={page} 
                    className={`page-item ${currentPage === page ? 'active' : ''}`}
                  >
                    <a 
                      className="page-link" 
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        handlePageChange(page);
                      }}
                    >
                      {page}
                    </a>
                  </li>
                ))}
                
                {/* Next Button */}
                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                  <a 
                    className="page-link" 
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      if (currentPage < totalPages) handlePageChange(currentPage + 1);
                    }}
                  >
                    Next
                  </a>
                </li>
              </ul>
            </nav>
          )}
        </div>
      </div>
    </main>
  );
};

export default DailySummary;
